<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">التنبيهات</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">التنبيهات</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :value="true" v-model="unseen" id="checkUnseen" @change="getList">
              <label class="form-check-label" for="checkUnseen">
                اظهار التنبيهات الغير مرئية فقط
              </label>
            </div>
          </div>
          <div class="col-12 col-sm-6 text-end">
            <button to="" @click.prevent="getList" class="btn btn-light me-4">
              <i class="fa-solid fa-arrows-rotate"></i> تحديث
            </button>
            <router-link v-if="checkAccess('admin_notifications_update')" to="" @click.prevent="seenAll" class="btn btn-warning">
              <i class="fa-solid fa-check-double me-1"></i> تمت مشاهدة الكل
            </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header"><div class="card-title">التنبيهات</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>التنبيه</th>
                            <th>المشاهدة</th>
                            <th>المشاهدة بواسطة</th>
                            <th>اخر تحديث</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td v-if="row.url"><router-link :to="row.url" @click="setAsSeen(row.id, indx)">{{ row.title }}</router-link></td>
                            <td v-else><router-link :to="row.url" @click.prevent="setAsSeen(row.id, indx)">{{ row.title }}</router-link></td>
                            <td>{{ (row.isSeen)? 'تمت' : 'لم يتم' }}</td>
                            <td>{{ (row.Admin)? row.Admin.name : '--' }}</td>
                            <td>{{ $shortDate(row.updatedAt) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'NotificationsList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      pages: [],
      unseen: false,
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      this.$http.get(`/api/admin/notifications/list?page=${this.currentPage}&unseen=${this.unseen}`).then(({data}) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async seenAll(){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تحويل كل التنبيهات إلى تمت المشاهدة ؟",
        showCancelButton: true,
        confirmButtonText: "تأكيد",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.get(`/api/admin/notifications/seenAll`).then(({data}) => {
          this.getList();
          const nCount = document.getElementById('unseenNotifications');
          if(nCount)
            nCount.innerHTML = 0;
          toast('تم تغيير حالة التنبيهات بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على تغيير حالة التنبيهات');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    setAsSeen(id, indx){
      if(!this.rows[indx].isSeen)
        this.$http.get(`/api/admin/notifications/seen/${id}`);
    }
  },
  created(){
    this.getList();
  }
}
</script>
